import React, { Component } from 'react'
import { css, Theme, Grid } from "@bdfx/mergado-ui-kit"
import { iconDisabledColor, StyledCell as SC } from "./tools-panel";
import { RenderCellsType } from 'shape-edit/containers/right-panel';
import { ActiveViewType } from 'template-edit/containers/Editor';

interface Props {
    enabledCells: RenderCellsType[]
    activeView: ActiveViewType
}

class TabsPanel extends Component<Props> {
    constructor(props) {
        super(props);
    }

    render() {
        const { enabledCells, activeView } = this.props

        return <StyledPanelGrid cols="40px" style={{ marginTop: '70px' }}>
            {enabledCells.map((cell, i) => {
                const isLast = i === enabledCells.length - 1
                return <React.Fragment key={`cell_${i}`}>
                    <StyledCell title={cell.title} className={`radius-right-none ${cell.activeView === activeView && 'active-grid'}`} style={{ overflow: 'hidden' }}>
                        {cell.button}
                    <Number>{i+1}</Number>
                    </StyledCell>
                    {!isLast &&
                        <Line></Line>
                    }
                </React.Fragment>
            })}
        </StyledPanelGrid>
    }
}

const Number = css("div")({
    display: "inline-block",
    position: "absolute",
    left: "2px",
    fontSize: "9px",
    color: "#a0a0a0",
    fontWeight: "bold",
})

const Line = css("div")({
    minHeight: "30px",
    background: "none",
    marginRight: "45%",
    fontSize: "9px",
    lineHeight: "30px",
    fontWeight: "bold",
    color: "#bbb",
    borderRight: "2px solid #e0e0e0",
    '@media screen and (max-height: 640px)': {
        minHeight: "20px",
    },
    '@media screen and (max-height: 540px)': {
        minHeight: "10px",
    },
    '@media screen and (max-height: 440px)': {
        minHeight: "2px",
    },
    '@media screen and (max-height: 340px)': {
        minHeight: "0px",
    },
})

const StyledCell = css(SC)({
    opacity: 0.5,
    position: "relative",
    paddingLeft: "2px",
    paddingTop: "2px",

    "&.active-grid": {
        opacity: 1,
    },
    '@media screen and (max-height: 500px)': {
        ' button': {
            width: '26px',
            height: '26px',
            padding: '0px',
        }
    },
})

const StyledPanelGrid = css(Grid)({
    borderRadius: '3px solid gray',
    textAlign: 'center',
    alignSelf: 'center',
    ' .active': {
        zIndex: 99,
        marginRight: '5px',
    },
    ' .active-grid': {
        width: '40px',
    },
    '.active .muk-icon--box-light': {
        path: {
            stroke: '#fff',
            strokeWidth: .5,
            color: Theme.blue,
            fill: Theme.blue
        },
    },
    '.not-active .muk-icon--box-light': {
        path: {
            stroke: '#fff',
            strokeWidth: .5,
            color: iconDisabledColor,
            fill: iconDisabledColor
        },
    },
    ' .radius-right-none': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    }
})


export default TabsPanel